import { withPath } from "library/api/api";
import { postHref } from "library/api/httpMethods";
import { getIsProduction } from "library/browser";
import { Ticket } from "library/zendeskAPI/types";
import { getHref } from "../httpMethods";
import {
  CreateTicketResponse,
  CreateZendeskTicketRequest,
  Field,
  ZendeskStatus,
} from "./types.generated";

type CreateZendeskTicket = {
  requester: {
    name: string;
    email: string;
  };
  groupId: number;
  subject: string;
  comment: string;
  ticketFormId: number;
  customFields: Field[];
  isNZ: boolean;
};

const brandIdAu = { prod: 360000819398, nonProd: 360001571557 };
const brandIdNz = { prod: 360000844397, nonProd: 360001572078 };

const arrayToObject = (
  customFields: Field[],
  envKey: string,
): CreateZendeskTicketRequest["custom_fields"] =>
  customFields.reduce((acc, curr) => {
    acc[curr.id[envKey]] = curr.value;
    return acc;
  }, {});

export const createTicket = (
  {
    requester: { name: requesterName, email: requesterEmail },
    groupId,
    subject,
    comment,
    ticketFormId,
    customFields,
    isNZ,
  }: CreateZendeskTicket,
  token: string,
) => {
  const isProduction = getIsProduction();
  const envKey = isProduction ? "prod" : "nonProd";

  const ticket: CreateZendeskTicketRequest = {
    requester_email: requesterEmail,
    requester_name: requesterName,
    ticket_form_id: ticketFormId,
    brand_id: isNZ ? brandIdNz[envKey] : brandIdAu[envKey],
    group_id: groupId,
    tags: ["channel_lsc"],
    subject,
    comment,
    custom_fields: arrayToObject(customFields, envKey),
  };

  return postHref<CreateTicketResponse>(
    withPath(`v1/zendesk/${token}/tickets`),
    ticket,
  );
};

const getTicketStatus = (ticketId: string, token: string) =>
  getHref<ZendeskStatus>(
    withPath(`v1/zendesk/${token}/tickets/${ticketId}`),
  ).then((resp) => resp.data.status);

export const getTicketsStatuses = (
  ticketIds: string[],
  token: string,
): Promise<Ticket["status"][]> =>
  Promise.all(ticketIds.map((ticketId) => getTicketStatus(ticketId, token)));
